import { Service } from 'core/types/service';

import usePaginationHandler from './usePaginationHandler';

export default function useServiceList() {
  return usePaginationHandler<Service>('services/list');
}
